import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

const DateRangePicker = ({
  selectedDates = [],
  onSelect,
  disabledDates = [],
  disableAllDates = false,
  exceptDates = [],
  disableDate, // Custom disable function from parent
  customClassNames = {
    selected: "custom-selected",
    recent: "custom-recent-selected",
  },
  customStyles = {
    day: { border: "none" },
  },
  containerStyles = {},
}) => {
  return (
    <div style={containerStyles}>
      <DayPicker
        mode="multiple"
        disabled={(date) => {
          // If disableAllDates is true, disable all dates except exceptDates
          if (disableAllDates) {
            if (exceptDates.length > 0) {
              const isExceptDate = exceptDates.some(
                (exceptDate) => new Date(exceptDate).toDateString() === date.toDateString()
              );
              return !isExceptDate; // Only allow exceptDates
            }
            return true; // Disable all if no exceptDates
          }

          // Use custom disable function if provided (for today and past dates)
          if (disableDate) {
            return disableDate(date);
          }

          // Default: disable today and past dates
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date <= today;
        }}
        selected={selectedDates}
        onSelect={onSelect}
        modifiersClassNames={{
          selected: customClassNames.selected,
        }}
        styles={customStyles}
      />
    </div>
  );
};

export default DateRangePicker;
